module.exports = __webpack_public_path__ + "img/pl.dfb064d1.svg";